import { gql } from '@apollo/client';

export const CREATE_USER = gql`
  mutation insert_users($objects: [users_insert_input!]!) {
    insert_users(objects: $objects) {
      returning {
        id
        email
      }
    }
  }
`;

export const CREATE_EMPLOYEE = gql`
  mutation insert_employees($objects: [employees_insert_input!]!) {
    insert_employees(objects: $objects) {
      returning {
        active
        code
        created_at
        employee_name
        id
        merchant_id
        updated_at
        user_id
      }
    }
  }
`;

export const UPDATE_EMPLOYEE = gql`
  mutation update_employees($id: uuid!, $object: employees_set_input!) {
    update_employees(where: { id: { _eq: $id } }, _set: $object) {
      returning {
        active
        code
        created_at
        employee_name
        id
        merchant_id
        updated_at
        user_id
      }
    }
  }
`;

export const CREATE_USER_LOCATION = gql`
  mutation insert_user_locations($objects: [user_locations_insert_input!]!) {
    insert_user_locations(
      objects: $objects
      on_conflict: {
        constraint: user_locations_pkey
        update_columns: [location]
      }
    ) {
      returning {
        location
        user_id
      }
    }
  }
`;

export const CREATE_REFERRAL = gql`
  mutation insert_referrals($objects: [referrals_insert_input!]!) {
    insert_referrals(
      objects: $objects
      on_conflict: {
        constraint: referrals_pkey
        update_columns: [
          merchant_name
          merchant_address
          merchant_phone
          code
          active
        ]
      }
    ) {
      returning {
        created_at
        merchant_name
        merchant_address
        merchant_phone
        code
        active
        id
      }
    }
  }
`;

export const UPDATE_REFERRAL = gql`
  mutation update_referrals($id: uuid!, $object: referrals_set_input!) {
    update_referrals(where: { id: { _eq: $id } }, _set: $object) {
      returning {
        created_at
        merchant_name
        merchant_address
        merchant_phone
        code
        active
        id
      }
    }
  }
`;

export const CREATE_REWARD = gql`
  mutation insert_rewards($objects: [rewards_insert_input!]!) {
    insert_rewards(objects: $objects) {
      returning {
        balance
        user_id
      }
    }
  }
`;

export const CREATE_ACTIVITY = gql`
  mutation insert_activities($objects: [activities_insert_input!]!) {
    insert_activities(objects: $objects) {
      returning {
        id
        amount
      }
    }
  }
`;

export const UPDATE_REWARD = gql`
  mutation update_rewards($userid: String!, $object: rewards_set_input!) {
    update_rewards(where: { user_id: { _eq: $userid } }, _set: $object) {
      returning {
        balance
        user_id
      }
    }
  }
`;

export const CREATE_PURCHASE = gql`
  mutation insert_purchases($objects: [purchases_insert_input!]!) {
    insert_purchases(objects: $objects) {
      returning {
        id
        promotion {
          id
          created_at
        }
        invoice_id
        amount
        paid
        quantity
      }
    }
  }
`;

export const UPDATE_PURCHASE = gql`
  mutation update_purchases($id: uuid!, $object: purchases_set_input!) {
    update_purchases(where: { id: { _eq: $id } }, _set: $object) {
      returning {
        id
        promotion {
          id
          created_at
        }
        invoice_id
        amount
        paid
        deleted_at
      }
    }
  }
`;

export const UPDATE_SERVICE = gql`
  mutation update_services($id: uuid!, $object: services_set_input!) {
    update_services(where: { id: { _eq: $id } }, _set: $object) {
      returning {
        active
        id
      }
    }
  }
`;

export const CREATE_SERVICE = gql`
  mutation upsert_services($objects: [services_insert_input!]!) {
    insert_services(
      objects: $objects
      on_conflict: {
        constraint: services_pkey
        update_columns: [service_name, price, active]
      }
    ) {
      returning {
        id
        service_name
        price
      }
    }
  }
`;

export const UPDATE_MERCHANT = gql`
  mutation update_merchants($id: uuid!, $object: merchants_set_input!) {
    update_merchants(where: { id: { _eq: $id } }, _set: $object) {
      returning {
        id
        business_name
        phone_number
        address
        location
        description
        background_url
        logo_url
        email
        country
        currency
        onboarded
        opennode_key_public
        provider_key
      }
    }
  }
`;

export const CREATE_SCAN_KEY = gql`
  mutation insert_scan_keys($objects: [scan_keys_insert_input!]!) {
    insert_scan_keys(
      objects: $objects
    ) {
      returning {
        id
        merchant_id
        created_at
      }
    }
  }
`;

export const CREATE_MERCHANT = gql`
  mutation upsert_merchants($objects: [merchants_insert_input!]!, $update: [merchants_update_column!]!) {
    insert_merchants(
      objects: $objects
      on_conflict: {
        constraint: merchants_user_id_key
        update_columns: $update
      }
    ) {
      returning {
        id
        approved
        business_name
        background_url
        logo_url
        description
        phone_number
        address
        location
        email
        country
        currency
        onboarded
        opennode_key_public
        provider_key
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation update_users($id: String!, $user: users_set_input!) {
    update_users(where: { id: { _eq: $id } }, _set: $user) {
      affected_rows
      returning {
        id
        name
        phone
        email
        bio
        city
        state
        country
        avatar
        username
        btc_beach_username
        role
        balance {
          user_id
          reward
          balance
          cashback
        }
        referrals {
          id
          used_date
        }
      }
    }
  }
`;

export const FOLLOW_USER = gql`
  mutation($followingId: String!, $notify: Boolean) {
    insert_follows(
      objects: [
        { following_id: $followingId, notify: $notify }
      ]
    ) {
      affected_rows
    }
  }
`;

export const UPDATE_FOLLOWS = gql`
  mutation update_follows($id: uuid!, $object: follows_set_input!) {
    update_follows(where: { id: { _eq: $id } }, _set: $object) {
      affected_rows
      returning {
        id
        notify
      }
    }
  }
`;

export const UNFOLLOW_USER = gql`
  mutation($followingId: String!, $userId: String!) {
    delete_follows(
      where: {
        follower_id: { _eq: $userId }
        following_id: { _eq: $followingId }
      }
    ) {
      affected_rows
    }
  }
`;

export const LIKE_POST = gql`
  mutation($postId: uuid!, $userId: String!) {
    insert_likes(objects: [{ post_id: $postId, user_id: $userId }]) {
      affected_rows
    }
  }
`;

export const DELETE_LIKE = gql`
  mutation($postId: uuid!, $userId: String!) {
    delete_likes(
      where: { user_id: { _eq: $userId }, post_id: { _eq: $postId } }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_POST = gql`
  mutation($id: uuid!) {
    delete_posts(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;

export const CREATE_POST = gql`
  mutation insert_posts($objects: [posts_insert_input!]!) {
    insert_posts(objects: $objects) {
      returning {
        id
        caption
        url
        merchant {
          business_name
        }
      }
    }
  }
`;

export const CREATE_DISCOUNT = gql`
  mutation upsert_discount_codes($objects: [discount_codes_insert_input!]!) {
    insert_discount_codes(
      objects: $objects
      on_conflict: {
        constraint: discount_codes_promotion_id_product_id_key
        update_columns: [codes]
      }
    ) {
      returning {
        id
        user_id
        promotion_id
        product_id
        codes
      }
    }
  }
`;

export const CREATE_PROMOTION = gql`
  mutation insert_promotions($objects: [promotions_insert_input!]!) {
    insert_promotions(objects: $objects) {
      returning {
        id
        discount_percentage
        giveaway_percentage
        giveaway_purchases_count
        giveaway_pool_count
        referral_percentage
        limit_quantity
        giveaway_pool
        number_of_promos
        promo_period
        start_date
        end_date
        active
        product_id
        codes
        discount_codes {
          id
          user_id
          promotion_id
          product_id
          codes
        }
        special_instructions
      }
    }
  }
`;

export const CREATE_PRODUCT = gql`
  mutation insert_products($objects: [products_insert_input!]!) {
    insert_products(objects: $objects, on_conflict: {
      constraint: products_pkey,
      update_columns: [
        title
        description
        media_url
        price
      ]
      }) {
      returning {
        id
        title
        description
        media_url
        price
      }
    }
  }
`;

export const UPDATE_PROMOTION = gql`
  mutation update_promotions($id: uuid!, $object: promotions_set_input!) {
    update_promotions(where: { id: { _eq: $id } }, _set: $object) {
      affected_rows
      returning {
        id
        discount_percentage
        giveaway_percentage
        giveaway_purchases_count
        giveaway_pool_count
        referral_percentage
        limit_quantity
        giveaway_pool
        number_of_promos
        promo_period
        start_date
        end_date
        active
        product_id
        featured
        codes
        discount_codes {
          id
          user_id
          promotion_id
          product_id
          codes
        }
        special_instructions
      }
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation update_products($id: uuid!, $object: products_set_input!) {
    update_products(where: { id: { _eq: $id } }, _set: $object) {
      affected_rows
      returning {
        id
        title
        description
        media_url
        price
        active
        limit_quantity
        category_id
        addons {
          product_id
          addon_id
        }
      }
    }
  }
`;

export const CREATE_ADD_ONS = gql`
mutation insert_addons($objects:[addons_insert_input!]!) {
  insert_addons(objects: $objects) {
    affected_rows
    returning {
      id
      title
      price
      user_id
    }
  }
}
`;

export const UPDATE_ADD_ONS = gql`
mutation update_add_ons($object: addons_set_input, $id:uuid!){
  update_addons(_set: $object, where: {id: {_eq:$id}}) {
    affected_rows
  }
}
`;

export const UPSERT_ADD_ONS = gql`
mutation upsert_addons($objects:[addons_insert_input!]!) {
  insert_addons(objects: $objects, on_conflict: {constraint: addons_pkey, update_columns: [title, price]}) {
    affected_rows
    returning {
      id
      title
      price
      user_id
    }
  }
}
`;

export const CREATE_PRODUCTS_ADD_ONS = gql`
  mutation insert_products_addons($objects:  [products_addons_insert_input!]!) {
    insert_products_addons(objects: $objects) {
      affected_rows
    }
  }
`;

export const DELETE_PRODUCTS_ADD_ONS = gql`
  mutation delete_products_addons ($product_id: uuid!) {
    delete_products_addons(where: {product_id: {_eq: $product_id }}) {
      affected_rows
    }
  }
`;

export const CREATE_WAITROOM = gql`
  mutation insert_waitrooms($objects: [waitrooms_insert_input!]!) {
    insert_waitrooms(objects: $objects) {
      returning {
        id
        start_time
        end_time
        merchant {
          id
          business_name
        }
        user {
          name
        }
      }
    }
  }
`;

export const UPDATE_WAITROOM = gql`
  mutation update_waitrooms($id: uuid!, $object: waitrooms_set_input!) {
    update_waitrooms(where: { id: { _eq: $id } }, _set: $object) {
      returning {
        active
        id
      }
    }
  }
`;

export const CREATE_LIKE = gql`
  mutation($user_id: String!, $promotion_id: uuid, $product_id: uuid) {
    insert_likes(
      objects: [
        {
          user_id: $user_id
          promotion_id: $promotion_id
          product_id: $product_id
        }
      ]
    ) {
      affected_rows
    }
  }
`;

export const DISLIKE = gql`
  mutation($user_id: String!, $promotion_id: uuid, $product_id: uuid) {
    delete_likes(
      where: {
        user_id: { _eq: $user_id }
        promotion_id: { _eq: $promotion_id }
        product_id: { _eq: $product_id }
      }
    ) {
      affected_rows
    }
  }
`;

export const SUPPORT = gql`
  mutation insert_support_tickets_one($message: String!) {
    insert_support_tickets_one(object: {message: $message}) {
      message
      id
      user_id
      created_at
    }
  }
`;

export const SUGGESTION = gql`
  mutation insert_suggestions_one($object: suggestions_insert_input!) {
    insert_suggestions_one(object: $object) {
      id
      user_id
      business_name
      business_phone
      business_address
      business_email
      description
      created_at
    }
  }
`;

export const BITCOIN_MEETUP = gql`
  mutation insert_bitcoin_meetups_one($object: bitcoin_meetups_insert_input!) {
    insert_bitcoin_meetups_one(object: $object) {
      id
      datetime
      title
      description
      user_id
      created_at
    }
  }
`;

export const DELETE_BLOCK_TOKEN = gql`
  mutation($id: uuid!, $userId: String!) {
    delete_block_tokens(
      where: { user_id: { _eq: $userId }, id: { _eq: $id } }
    ) {
      affected_rows
    }
  }
`;

export const UPDATE_DEFAULT_PROVIDER = gql`
  mutation update_provider_keys($id: uuid!, $default: Boolean!) {
    update_provider_keys(where: { id: { _eq: $id } }, _set: { default: $default }) {
      returning {
        id
        default
      }
    }
  }
`;